import { render, staticRenderFns } from "./ViewSupplierComponent.vue?vue&type=template&id=6ab8726a&"
import script from "./ViewSupplierComponent.vue?vue&type=script&lang=js&"
export * from "./ViewSupplierComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports